import { useMemo } from 'react';
import { createTheme } from '@mui/material/styles';
import colors from './colors';

const defaultTheme = createTheme();

export const useCustomTheme = () => {

  const theme = useMemo(() => {
    const focusVisibleStyle = {
      outline: `2px solid ${colors.focusOutlineColor}`,
    }
   return createTheme({
    typography: {
      fontFamily: 'Montserrat Regular, Arial, Helvetica, sans-serif;',
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: `
          ::selection {
            background-color: #3a833c;
            color: #ffffff;
          }
        `,
      },
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            '&.MuiButton-root ': {
              textTransform: 'capitalize',
            },
            '&:focus-visible': focusVisibleStyle,
          },
        },
      },
      MuiTouchRipple: {
        styleOverrides: {
          root: {
            opacity: 0.8,
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            '&.Mui-error': {
              color: colors.prussian,
            },
            '&.Mui-focused': {
              color: colors.slate,
            },
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          underline: {
            '&.Mui-error:after': {
              borderBottomColor: colors.dragon,
            },
          },
        },
      },
      MuiTableContainer: {
        styleOverrides: {
          root: {
            borderRadius: '3px',
            border: `1px solid ${colors.mercury}`,
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: colors.prussian,
            padding: '8px',
            borderRadius: '2px',
            fontSize: '0.75rem',
          },
          tooltipPlacementLeft: {
            margin: '0 4px',
            // This is used to adjust CSS applied via @media
            // queries.
            [defaultTheme.breakpoints.up('xs')]: {
              margin: '0 4px',
            },
          },
          tooltipPlacementRight: {
            margin: '0 4px',
            [defaultTheme.breakpoints.up('xs')]: {
              margin: '0 4px',
            },
          },
          tooltipPlacementTop: {
            margin: '4px 0',
            [defaultTheme.breakpoints.up('xs')]: {
              margin: '4px 0',
            },
          },
          tooltipPlacementBottom: {
            margin: '4px 0',
            [defaultTheme.breakpoints.up('xs')]: {
              margin: '4px 0',
            },
          },
        },
      },
      MuiBottomNavigationAction: {
        styleOverrides: {
          root: {
            '&:focus-visible': focusVisibleStyle,
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            '&:focus-visible': focusVisibleStyle,
          },
        },
      },
       MuiChip: {
      styleOverrides: {
        root: {
          '&.mint': {
            backgroundColor: colors.mint,
          },
          '&.mintbold': {
            backgroundColor: colors.mint600,
          },
          '&.rose': {
            backgroundColor: colors.rose,
          },
          '&.peach': {
            backgroundColor: colors.peach300,
          },
          '&.blonde': {
            backgroundColor: colors.blonde,
          },
          '&.prussian': {
            backgroundColor: colors.prussian300,
          },
          '&.mercury': {
            backgroundColor: colors.mercury,
          },
          '&.muted': {
            backgroundColor: colors.mercury,
            color: colors.iron,
          },
        },
        label: {
          fontFamily: 'Proxima Nova',
          fontWeight: 400,
          fontSize: '13px',
          lineHeight: '16px',
          color: colors.prussian,
          paddingLeft: '8px',
          paddingRight: '8px',
        },
        labelSmall: {
          fontFamily: 'Proxima Nova',
          fontWeight: 400,
          fontSize: '13px',
          lineHeight: '16px',
          color: colors.prussian,
          height: '20px',
          paddingTop: '1px',
          paddingLeft: '4px',
          paddingRight: '4px',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: colors.prussian,
          fontSize: '16px',
          // '&:hover': {
          //   backgroundColor: Fade({color: colors.leaf, }),
          // },
          '&:focus-visible': focusVisibleStyle,
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        checked: {},
        disabled: {},
        colorSecondary: {
          color: colors.prussian,
          '&$checked': {
            color: colors.leaf,
            '&:hover': {
              // backgroundColor: fade(colors.leaf, 0.15),
              // Reset on touch devices, it doesn't add specificity
              '@media (hover: none)': {
                backgroundColor: 'transparent',
              },
            },
          },
        },
      },
    },
  },
    palette: {
      primary: {
        main: colors.prussian,
        contrastText: '#fff',
      },
      secondary: {
        main: colors.jungle,
        contrastText: '#fff',
      },
    },

  })}, []);

  return theme;
}
